import { jsx as e, jsxs as t } from "react/jsx-runtime";
const d = ({
  width: o,
  height: r,
  className: n
}) => /* @__PURE__ */ e(
  "svg",
  {
    className: n,
    fill: "none",
    height: r,
    viewBox: "0 0 20 16",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e("g", { id: "Xnix/Line/Car", children: /* @__PURE__ */ t("g", { id: "Vector", children: [
      /* @__PURE__ */ e(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.40626 4.214C4.17526 2.312 5.10026 1 7.19426 1H12.8073C14.8993 1 15.8253 2.312 16.5953 4.214L17.3643 6.249C17.9372 6.25589 18.4636 6.56609 18.7473 7.064C18.9141 7.34762 19.0015 7.67094 19.0004 8V10.624C19.0077 11.2367 18.6984 11.8098 18.1823 12.14C17.9368 12.2929 17.6534 12.374 17.3643 12.374H2.63626C2.34709 12.374 2.06372 12.2929 1.81826 12.14C1.30208 11.8098 0.992816 11.2367 1.00013 10.624V8C0.999179 7.67128 1.08657 7.34832 1.25326 7.065C1.53689 6.56709 2.06327 6.25689 2.63626 6.25L3.40626 4.214Z",
          fillRule: "evenodd",
          id: "Vector-10",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M4.27308 12.375V13.688C4.29555 14.3892 3.74616 14.9761 3.04508 15C2.34399 14.9756 1.79504 14.3882 1.81808 13.687V12.14M2.63608 6.24902H17.3641M15.7281 12.374V13.687C15.6989 14.1443 15.9262 14.5798 16.3181 14.8173C16.7099 15.0548 17.2013 15.0548 17.5931 14.8173C17.9849 14.5798 18.2123 14.1443 18.1831 13.687V12.14M4.00008 9.50002H5.00008M15.0001 9.50002H16.0001",
          id: "Vector-11",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5"
        }
      )
    ] }) })
  }
);
export {
  d as Content
};
